<template>
  <div class="screen-4">
    <div class="container">
      <div class="row">
        <div class="col-12 col-lg-6 ">
          <p class="subtitle-light subtitle-normal banner-text text-center text-lg-left m-lg-0">
            {{ $t(locale.s4.message) }}
          </p>
        </div>
        <div class="col-12 col-lg-6 ">
          <ButtonWidget uri="#contacts" :listeners="[openContactForm, sendMetrics]" class="standard-button transition d-block mt-0 mr-lg-0">
            {{ $t(locale.s4.button) }}
          </ButtonWidget>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery';
import Vue from 'vue';
import ButtonWidget from "@/components/common/ButtonWidget";
import stringsKeys from "@/i18n/strings.json";

export default Vue.extend({
  name: 'ScreenBanner',
  components: {
    ButtonWidget,
  },
  data: () => {
    return {
      locale: stringsKeys,
    };
  },
  methods: {
    openContactForm: function (ev) {
      ev.preventDefault();
      this.$modal.show('contact-form')
      // var screenId = ev.target.attributes.href.value;
      // $([document.documentElement, document.body]).animate({
      //   scrollTop: $(screenId).offset().top
      // }, 300);

    },
    sendMetrics: function () {
      ym(56244529, 'reachGoal', 'WRITE_2')
      // this.$metrika.hit(56244529, 'reachGoal', 'WRITE_2');
    },
  },
});
</script>

<style lang="scss">
@import "src/scss/colors";
@import "src/scss/constants";
@import "src/scss/mixins/media";

.screen-4 {
  background-color: $black;
  padding-top: 50px;
  padding-bottom: 50px;
  @media (min-width: 576px) {
    padding-top: 54px;
    padding-bottom: 54px;
  }
  @include more($bp-tablet) {
    background-repeat: no-repeat;
    background-image: url('~@/assets/img/bg-green-dots.svg');
    background-position-y: center;
  }
  @media (min-width: 992px) {
    max-width: 1200px;
    margin-left: auto;
    margin-right: auto;
    margin-top: -67px;
  }
  @media (min-width: 1440px) {
    padding-left: 55px;
    padding-right: 55px;
  }

  .banner-text{
    font-size: 22px;
    line-height: 27px;
  }
}
</style>